import React, { useState } from 'react';
import { connect } from 'react-redux';
import { RootState } from 'typesafe-actions';
import { FilledInput, FormControl, IconButton, InputAdornment, InputLabel, TextField } from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import {
  toggleFullSize, toggleLogin,
} from '../state/uiControl/uiControl.actions';
import './Login.css';
import { loginUser } from '../state/user/user.actions';
import closeIcon from '../assets/images/close1.svg';

export const Login: React.FC<LoginProps> = ({
  showLogin,
  loginUser,
  toggleLogin,
  errorData
}) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, toggleShowPassword] = useState(false);
  const [error, setError] = useState(false);

  let errorMessage = "";
  if (errorData) {
    if (errorData.optionalData) {
      errorMessage = Object.values(errorData.optionalData)[0];
    } else if (errorData.secondaryStatusCode === "PORTA-5150") {
      errorMessage = 'Your Email/Seabourn Club Number and/or password does not match our records. Please try again.';
    }
  }

  if (!showLogin) return <div />;

  return <div className='loginContainer' onClick={() => toggleLogin()}>
    <div className='login' onClick={(e) => e.stopPropagation()}>
      <button className='close' onClick={() => toggleLogin()}>
        <img alt="close" src={closeIcon} />
      </button>
      <div className='title'>Log In</div>
      <label className='requiredNote'>
        All fields are required unless noted as optional.
      </label>
      <form noValidate autoComplete="off">
        <TextField
          label="Seabourn Club number or email"
          variant="filled"
          error={error && !email}
          onChange={(e) => { setEmail(e.target.value); }}
        />
        <FormControl variant="filled">
          <InputLabel
            error={error && !password}
          >Password</InputLabel>
          <FilledInput
            error={error && !password}
            type={showPassword ? 'text' : 'password'}
            onChange={(e) => { setPassword(e.target.value); }}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => toggleShowPassword(!showPassword)}
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
        {errorMessage && (
          <div className="error">
            {errorMessage}
          </div>
        )}
      </form>
      <div className="buttonContainer">
        <button className="submitButton" onClick={() => {
          if (email && password) {
            loginUser({ username: email, secret: password });
          } else {
            setError(true);
          }
        }}>Login</button>
      </div>
    </div>
  </div>;


};

const mapStateToProps = (state: RootState) => ({
  showLogin: state.uiControl.showLogin,
  errorData: state.user.errorData,
});

const dispatchProps = {
  toggleFullSize,
  loginUser: loginUser.request,
  toggleLogin
};

type LoginProps = ReturnType<typeof mapStateToProps> & typeof dispatchProps;

export default connect(
  mapStateToProps,
  dispatchProps
)(Login);